import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { LocalStorageService } from "ngx-webstorage";
import { Container } from "src/app/shared/model/container.models";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import { mobileFooterMenuLists, Modalconfig, FooterMenuComponents } from "src/app/shared/constants";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { EditVideoComponent } from "../shared/components/edit-video/edit-video.component";
import { EditAudioComponent } from "../shared/components/edit-audio/edit-audio.component";
import { AddImageComponent } from '../shared/components/add-image/add-image.component';
import { AddEditChallengeBlockComponent } from 'src/app/playbook-editor/ContentComponents/challenge-block/add-edit-challenge-block/add-edit-challenge-block.component';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { clone } from "lodash";
import { Subscription } from "rxjs";
import { Company } from "src/app/shared/interfaces/company";
import { CommunicationService } from "src/app/shared/services/communication/communication.service";
import { profileRoles ,sessionProfile } from "src/app/shared/interfaces/sessionStorageModel";
import { SessionStorageService } from 'src/app/shared/services/session-storage/session-storage.service';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';

@Component({
    selector: "app-mobile-editor",
    templateUrl: "./mobile-editor.component.html",
    styleUrls: ["./mobile-editor.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MobileEditorComponent implements OnInit, OnDestroy {
  @Input() container: Container;
  @Input() playbookId;
  @Input() videoListPerSection;

  hideContent = false;
  reorderContent = false;
  url: string;
  footerMenuLists = mobileFooterMenuLists;
  itemsPerSlide: number = 4;
  modalRef: BsModalRef;
  isPreviewMode: boolean = false;
  contentSubscription: Subscription;
  isVideoPlaylist: boolean = false;
  isViewerMode: boolean = false;
  noVideoPresent: boolean = false;
  company: Company;
  profileData: sessionProfile;
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  constructor(
    private commonHttpService: CommonHttpService,
    private storage: LocalStorageService,
    private modalService: BsModalService,
    private communicationService: CommunicationService,
    private sessionStorageService: SessionStorageService
  ) { }

  ngOnInit() {
    this.url = window.location.href;
    this.hideContent = false;
    this.company = this.communicationService.getSessionStoredCompany('company');
    this.noVideoPresent = !this.videoListPerSection.length ? true : false;
    this.profileData = this.sessionStorageService.getLoggedInProfileDetail();
    this.initializeStorageData();
    this.editVideoObserve();
    this.editAudioObserve();
    this.editImageObserve();
    this.editChallengeBlockObserve();
    this.getFooterData();    
  }

  disableSlider(footerMenu) {
    if (
      footerMenu.menu === FooterMenuComponents.coaching ||
      footerMenu.menu === FooterMenuComponents.lms
    ) {
      if (this.checkProfileRole()) {
        footerMenu.enabled = false;
      }
    }
    if (footerMenu.menu === FooterMenuComponents.videos) {
      return this.noVideoPresent;
    } else if (footerMenu.menu === FooterMenuComponents.coaching) {
      return !this.company.hasCoachingAccess || this.checkProfileRole();
    } else if (footerMenu.menu === FooterMenuComponents.lms) {
      return (
        !this.company.enableLearningCenterAccess || this.checkProfileRole()
      );
    }
  }

  checkProfileRole() {
    return [
      profileRoles.playbookOwner,
      profileRoles.vPlaybookReader,
      profileRoles.companyReader,
      profileRoles.specificVPlaybookAdmin,
    ].includes(this.profileData.role);
  }

  getFooterData() {
    this.commonHttpService.get({
      uri: `/api/PlaybookMobileView/GetPlaybookFooterItems/${this.playbookId}?companyId=${this.company.id}`,
    }).subscribe((res: any) => {
      this.footerMenuLists.forEach((footerMenu) => {
        res.forEach((menuItem) => {
          if (footerMenu.menu === menuItem.menu) {
            footerMenu.enabled = menuItem.enabled;
            footerMenu.order = menuItem.order;
          }
        });
      });
      this.footerMenuLists.sort((a, b) => a.order - b.order);
      this.storage.store('footerContent', this.footerMenuLists);
    });
  }

  editVideoObserve() {
    this.contentSubscription = this.storage.observe('videoContentBlock').subscribe((contentBlock) => {
      if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location )) && contentBlock && !this.contentSubscription.closed) {
        const vidBlock = clone(contentBlock.videoBlock);
        if (vidBlock.url && vidBlock.url.includes('assets')) {
          vidBlock.url = null;
        }
        const initialState = {
          contentBlock,
          vidBlock
        };
        this.modalRef = this.modalService.show(EditVideoComponent,
          Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
        this.modalRef.content.onclose.subscribe((videoObj: any) => {
          this.modalRef.hide();
          if (videoObj) {
            this.storage.store("uploadVideoContent", { videoObj: videoObj, videoListPerSection: this.videoListPerSection });
          }
          this.storage.store('videoContentBlock', null);
        });
      }
    });
  }

  editAudioObserve() {
    this.contentSubscription = this.storage.observe('audioContentBlock').subscribe((contentBlock) => {
      if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location )) && contentBlock && !this.contentSubscription.closed) {
        const audBlock = clone(contentBlock.audioBlock);
        const initialState = {
          contentBlock,
          audBlock
        };
        this.modalRef = this.modalService.show(EditAudioComponent,
          Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
        this.modalRef.content.onclose.subscribe((audioObj: any) => {
          this.modalRef.hide();
          if (audioObj) {
            this.storage.store("uploadAudioContent", audioObj);
          }
          this.storage.store('audioContentBlock', null);
        });
      }
    });
  }

  editImageObserve() {
    this.contentSubscription = this.storage.observe('imageContentBlock').subscribe((imageContents) => {
      if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location )) && imageContents && !this.contentSubscription.closed) {
        const initialState = {
          contentBlock: imageContents.contentBlock,
          items: imageContents.items,
          pageId: imageContents.pageId,
          sectionId: imageContents.sectionId,
          isdraftmode: imageContents.isdraftmode,
          pageTemplateId: imageContents.pageTemplateId,
          openFromMobile: true
        };
        this.modalRef = this.modalService.show(AddImageComponent,
          Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
        this.modalRef.content.onclose.subscribe((imageObj: any) => {
          this.modalRef.hide();
          if (imageObj) {
            this.storage.store("uploadImageContent", imageObj);
          }
          this.storage.store('imageContentBlock', null);
        });
      }
    });
  }

  editChallengeBlockObserve() {
    this.contentSubscription = this.storage.observe('challengeContentBlock').subscribe((challengeContents) => {
      if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location )) && challengeContents && !this.contentSubscription.closed) {
        const initialState = {
          contentBlockId: challengeContents.contentBlockId,
          playbookId: challengeContents.playbookId,
          adminId: challengeContents.adminId,
          challengeBlock: challengeContents.challengeBlock,
          sectionId: challengeContents.sectionId,
          pageId: challengeContents.pageId,
          isdraftmode: challengeContents.isdraftmode,
          openFromMobile: true
        };
        this.modalRef = this.modalService.show(AddEditChallengeBlockComponent,
          Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
        this.modalRef.content.onclose.subscribe((challengeObj: any) => {
          this.modalRef.hide();
          if (challengeObj) {
            this.storage.store("uploadChallengeContent", challengeObj);
          }
          this.storage.store('challengeContentBlock', null);
        });
      }
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.footerMenuLists, event.previousIndex, event.currentIndex);
    this.footerMenuLists[event.currentIndex].order = event.currentIndex;
    this.footerMenuLists[event.previousIndex].order = event.previousIndex;
  }

  showHideContent() {
    if (this.reorderContent) {
      localStorage.setItem('mobilePlaybookRow', null);
      this.reorderContent = !this.reorderContent;
      this.storage.store('isReorder', this.reorderContent);
    }
    this.hideContent = !this.hideContent;
    localStorage.removeItem('hiddenContentRows');
    localStorage.removeItem('hiddenContainers');
    this.storage.store('isShowHide', this.hideContent);
  }

  saveFooterMenus() {
    let order = 0;
    let mobileFooterList = [];
    mobileFooterList = this.footerMenuLists.reduce((previousValue, currentValue) => {
      previousValue.push({ menu: currentValue.menu, enabled: currentValue.enabled, order: ++order });
      return previousValue;
    }, []);

    this.commonHttpService.put({
      uri: `/api/PlaybookMobileView/SavePlaybookFooterItems`,
      object: {
        playbookId: this.playbookId,
        footerItemsRows: mobileFooterList,
      },
    }).subscribe((res) => {
      const enabledMenuFooter = mobileFooterList.filter(x => x.enabled);
      this.storage.store('footerContent', enabledMenuFooter);
    });
  }

  reorderContentFunc() {
    if (this.hideContent) {
      this.hideContent = !this.hideContent;
      this.storage.store('isShowHide', this.hideContent);
    }
    const MobilePlaybookRows = JSON.parse(localStorage.getItem('mobilePlaybookRow')) || [];
    if (this.reorderContent && MobilePlaybookRows.length) {
      this.commonHttpService.post({
        uri: `/api/PlaybookMobileView/ReOrderPlaybookContent`,
        object: {
          playbookId: this.playbookId,
          contentColumns: MobilePlaybookRows
        },
        message: {
          errorMessage: 'Something went wrong. Please try again.'
        }
      }).subscribe(() => {
        localStorage.setItem('mobilePlaybookRow', null);
        this.reorderContent = !this.reorderContent;
        this.storage.store('isReorder', this.reorderContent);
      });
    } else {
      this.reorderContent = !this.reorderContent;
      this.storage.store('isReorder', this.reorderContent);
      this.checkUnsavedHiddenContents();
    }
  }

  checkUnsavedHiddenContents() {
    const hiddenContainers = JSON.parse(localStorage.getItem("hiddenContainers")) || [];
    const hiddenContentRows = JSON.parse(localStorage.getItem("hiddenContentRows")) || [];
    if (hiddenContainers.length || hiddenContentRows.length) {
      const initialState = {
        msg: 'You have some unsaved data in the current playbook. Do you want to save these data?'
      };
      this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
        Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
      this.confModalSubsciber = this.confirmationModalRef.content.onclose.subscribe((isSaveData: boolean) => {
        if (isSaveData) {
          this.hidePlaybookContents();
        } else {
          localStorage.setItem('hiddenContainers', null);
          localStorage.setItem('hiddenContentRows', null);
          const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
          input !== null && input.tagName === 'IFRAME';
          let frame = document.getElementById('frameId');
          if (isIFrame(frame) && frame.contentWindow) {
              frame.contentWindow.location.reload();
          }
        }
        this.confirmationModalRef.hide();
        this.confModalSubsciber.unsubscribe();
      });
    }
  }

  checkUnsavedReorderContents() {
    const mobilePlaybookRows = JSON.parse(localStorage.getItem("mobilePlaybookRow")) || [];
    if (mobilePlaybookRows.length) {
      const initialState = {
        msg: 'You have some unsaved data in the current playbook. Do you want to save these data?'
      };
      this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
        Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
      this.confModalSubsciber = this.confirmationModalRef.content.onclose.subscribe((isSaveData: boolean) => {
        if (isSaveData) {
          this.reorderContentFunc();
        } else {
          localStorage.setItem('mobilePlaybookRow', null);
          const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
          input !== null && input.tagName === 'IFRAME';
          let frame = document.getElementById('frameId');
          if (isIFrame(frame) && frame.contentWindow) {
              frame.contentWindow.location.reload();
          }
        }
        this.confirmationModalRef.hide();
        this.confModalSubsciber.unsubscribe();
      });
    }
  }

  hidePlaybookContents() {
    if (this.reorderContent) {
      this.reorderContent = !this.reorderContent;
      this.storage.store('isReorder', this.reorderContent);
    }
    let contentRows = [];
    let sections = [];
    const hiddenContainers = JSON.parse(localStorage.getItem("hiddenContainers")) || [];
    const hiddenContentRows = JSON.parse(localStorage.getItem("hiddenContentRows")) || [];
    if (hiddenContentRows.length) {
      contentRows = hiddenContentRows.map((contentRow) => ({
        id: contentRow.id,
        isHide: contentRow.isHidden,
      }));
    }
    if (hiddenContainers.length) {
      sections = hiddenContainers.map((container) => ({
        id: container.id,
        isHide: container.isHidden,
      }));
    }
    if (this.hideContent && (contentRows.length || sections.length)) {
      this.commonHttpService.post({
        uri: `/api/PlaybookMobileView/HidePlaybookContent`,
        object: {
          playbookId: this.playbookId,
          contentRows: contentRows,
          sections: sections,
        },
      }).subscribe(() => {
        localStorage.setItem('hiddenContainers', null);
        localStorage.setItem('hiddenContentRows', null);
        this.hideContent = !this.hideContent;
        this.storage.store("isShowHide", this.hideContent);
      });
    } else {
      this.hideContent = !this.hideContent;
      this.storage.store("isShowHide", this.hideContent);
      this.checkUnsavedReorderContents();
    }
  }

  updateFooterContent() {
    let mobileFooterList = [];
    mobileFooterList = this.footerMenuLists.reduce((previousValue, currentValue) => {
      previousValue.push({ menu: currentValue.menu, enabled: currentValue.enabled, });
      return previousValue;
    }, []);
    const enabledMenuFooter = mobileFooterList.filter(x => x.enabled);
    this.storage.store('footerContent', enabledMenuFooter);
  }
  changeViewerMode() {
    this.removeStorageData();
    this.url = this.isPreviewMode ? this.url.replace('/playbook/', '/playbookeditor/') : this.url.replace('/playbookeditor/', '/playbook/');
    this.isPreviewMode = !this.isPreviewMode;
    this.isViewerMode = this.isPreviewMode;
  }

  removeStorageData() {
    if (this.reorderContent) {
      localStorage.setItem('mobilePlaybookRow', null);
      this.reorderContent = !this.reorderContent;
      this.storage.store('isReorder', this.reorderContent);
    }
    if (this.hideContent) {
      this.hideContent = !this.hideContent;
      localStorage.setItem('hiddenContentRows', null);
      localStorage.setItem('hiddenContainers', null);
      this.storage.store('isShowHide', this.hideContent);
    }
  }
  initializeStorageData() {
    this.storage.store('isVideoPlaylist', null);
    localStorage.setItem('mobilePlaybookRow', null);
    localStorage.setItem('hiddenContentRows', null);
    localStorage.setItem('hiddenContainers', null);
    this.storage.store('isShowHide', this.hideContent);
    this.storage.store('isReorder', this.reorderContent);
    this.storage.store('videoContentBlock', null);
    this.storage.store('audioContentBlock', null);
    this.storage.store('imageContentBlock', null);
    this.storage.store('challengeContentBlock', null);
    this.storage.store('footerContent', null);

    this.storage.observe('isVideoPlaylist').subscribe((isVideoPlaylist) => {
      if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
        this.isVideoPlaylist = isVideoPlaylist;
        this.isViewerMode = isVideoPlaylist;
      }
    });

    this.storage.observe('isReorder').subscribe((isReorder) => {
      if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
        this.reorderContent = isReorder;
      }
    });

    this.storage.observe('isShowHide').subscribe((isShowHide) => {
      if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
        this.hideContent = isShowHide;
      }
    });
  }
  ngOnDestroy() {
    if (this.contentSubscription) {
      this.storage.clear();
      this.contentSubscription.unsubscribe();
    }
  }
}
